export const routes = {
  HOME: '/',
  SEARCH: '/search',
  TREK: '/trek',
  TOURISTIC_CONTENT: '/service',
  FLAT_PAGE: '/information',
  OFFLINE: '/offline',
  OUTDOOR_SITE: '/outdoor-site',
  OUTDOOR_COURSE: '/outdoor-course',
  TOURISTIC_EVENT: '/event',
} as const;
